function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00993E",
  d: "M640 0H0v480h640V0Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  d: "M640 80H0v120h640V80Zm0 200H0v120h640V280Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#C8312A",
  d: "M400 0H0v280h400V0Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  d: "M166.827 238.934 148.709 202.7v-72.469L194.003 94l45.291 36.231v54.354l18.118-18.121V202.7l-36.236 36.234h-54.349ZM69.388 127.816l4.795 14.763h15.521l-12.555 9.126 4.797 14.758-12.558-9.12-12.56 9.12 4.797-14.758-12.558-9.126H64.59l4.8-14.763Zm36.233-36.232 4.795 14.761h15.524l-12.561 9.121 4.797 14.763-12.555-9.12-12.558 9.12 4.797-14.763-12.56-9.121h15.524l4.797-14.76Zm36.234-36.237 4.794 14.761h15.522l-12.556 9.125L154.41 94l-12.555-9.126L129.294 94l4.797-14.767-12.555-9.125h15.519l4.8-14.761Zm176.764 72.469-4.797 14.763H298.3l12.561 9.126-4.8 14.758 12.558-9.12 12.558 9.12-4.798-14.758 12.556-9.126h-15.519l-4.797-14.763Zm-36.234-36.232-4.797 14.761h-15.519l12.555 9.121-4.797 14.763 12.558-9.12 12.56 9.12-4.797-14.763 12.555-9.121h-15.521l-4.797-14.76Zm-36.231-36.237-4.797 14.761h-15.524l12.558 9.125L233.594 94l12.56-9.126L258.709 94l-4.797-14.767 12.558-9.125h-15.521l-4.795-14.761Zm-52.15-18.119-4.798 14.766h-15.518l12.555 9.126-4.797 14.761 12.558-9.125 12.557 9.125-4.797-14.761 12.558-9.126h-15.521l-4.797-14.766Z"
});

var SvgAb = function SvgAb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 640 480",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ab.7e663754.svg";
export { ForwardRef as ReactComponent };